import { buildURL } from "@comparaonline/cloudinary-image";
import Paper from "@material-ui/core/Paper";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

import { getCardSize } from "../TipSlider/TipCard/Card/size";

const placeholderUrl = buildURL("v1570822351/assets/placeholders/tips/tip-card.svg");

const styles: StyleRulesCallback = theme => {
  const { spacing } = theme;
  const { width, height } = getCardSize(theme);
  return {
    root: {
      backgroundImage: `url(${placeholderUrl})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      margin: `${spacing.unit * 2}px 0`,
      minHeight: height,
      minWidth: width
    }
  };
};

export const BasePlaceholderCard: React.FC<WithStyles<typeof styles>> = ({ classes }) => (
  <Paper classes={classes} />
);

export const PlaceholderCard = withStyles(styles)(BasePlaceholderCard);
